module.exports = __webpack_public_path__ + "static/media/201IT223.dc82ef6c.jpg";